import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconClub = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M26.5,2.3c0,0.5,0,1,0,1.5c0,4.3,0,8.6,0,13c0,0.2-0.1,0.4-0.2,0.5c-3.2,2.8-8.2,2.9-11.6,0.2
	c-1-0.8-2.2-1.5-3.5-1.7c-1.6-0.3-3.1,0-4.5,0.6c-0.4,0.2-0.8,0.4-1.3,0.6c-0.2,0.1-0.2,0.2-0.2,0.4c0,3.3,0,6.6,0,10
	c0,0.2,0,0.3,0,0.5c0,0.6-0.3,1-0.8,1c-0.5,0-0.9-0.4-0.9-1c0-0.7,0-1.4,0-2.2c0-7.4,0-14.8,0-22.2c0-0.3,0.1-0.4,0.3-0.6
	C5.3,2,7,1.3,8.8,1.1c2.4-0.3,4.5,0.3,6.4,1.7c1,0.7,2,1.3,3.2,1.5c1.5,0.3,3,0.1,4.4-0.4C24,3.5,25.1,3,26.1,2.5
	C26.3,2.5,26.4,2.4,26.5,2.3z M5.2,15.3c0.1,0,0.2-0.1,0.3-0.1c0.5-0.2,1-0.4,1.5-0.5c2.2-0.6,4.3-0.7,6.5,0.1
	c0.9,0.3,1.6,0.9,2.3,1.4c2.8,2.1,6.2,2.2,8.8,0.3c0.2-0.1,0.3-0.3,0.3-0.5c0-3.6,0-7.2,0-10.7c0-0.1,0-0.2,0-0.3
	c-0.7,0.2-1.3,0.4-2,0.6c-1.8,0.5-3.6,0.6-5.4,0.1c-1.2-0.3-2.2-0.9-3.1-1.6C12.8,3.1,11,2.5,9.1,2.7C7.8,2.8,6.6,3.3,5.4,4
	C5.2,4.1,5.2,4.2,5.2,4.4c0,3.5,0,7,0,10.6C5.2,15.1,5.2,15.2,5.2,15.3z"/>
    </SvgIcon>
  );
};
// IconClub = pure(IconClub);
IconClub.displayName = 'IconClub';
IconClub.muiName = 'SvgIcon';

export default IconClub;



// WEBPACK FOOTER //
// ./src/components/Icons/IconClub.js